module.exports = __webpack_public_path__ + "img/12.30780f53.png";